import { defineSlotRecipe } from "@pandacss/dev";

export const aromaSection = defineSlotRecipe({
  className: "aroma-section",
  jsx: ["Section", "Container"],
  slots: ["root", "title", "container", "content", "footer"],
  base: {
    root: {
      width: "100%",
      m: "auto",
      display: "grid",
      base: {
        gridTemplateColumns: "1fr 2fr",
        gap: "gap.20",
        maxWidth: "1120px",
      },
      mdDown: {
        gridTemplateColumns: "1fr 2fr",
        gap: "gap.6",
        maxWidth: "912px",
      },
      smDown: {
        gridTemplateColumns: "1fr",
        gap: "gap.6",
      },
      xsDown: {
        gridTemplateColumns: "1fr",
        gap: "gap.4",
      },
    },
    title: {
      display: "flex",
      color: "content.neutral.base.subtle",
      flexDirection: "column",
      flexGrow: "1",
      base: {
        gap: "gap.4",
      },
      xsDown: {
        gap: "gap.2",
      },
    },
    container: {
      flexGrow: "2",
      background: "background.neutral.base.subtlest",
      borderRadius: "2xl",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "gap.6",
      base: {
        padding: "padding.10",
      },
      xsDown: {
        padding: "padding.4",
      },
      mdDown: {
        padding: "padding.6",
      },
    },
    footer: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "gap.2",
      padding: "padding.4",
    },
  },
  variants: {
    withFooter: {
      true: {
        content: {
          base: {
            paddingBottom: "padding.6",
          },
          xsDown: {
            paddingBottom: "padding.4",
          },
        },
      },
    },
    titleAsContent: {
      true: {
        root: {
          base: {
            gridTemplateColumns: "1fr",
          },
        },
      },
    },
  },
});
